import {useEffect, useState} from 'react'
import {BrowserRouter, Routes, Route} from "react-router-dom"
import Home from "./components/Home"
import MainPage from "./components/MainPage";
import TeamsPage from "./components/TeamsPage/TeamsPage";
import { TabProvider } from "./context/TabContext";
import { AppStateProvider } from './context/AppStateContext';
import socketIO from "socket.io-client";

const API_URL = (() => {
  if (typeof window === 'undefined') return '';

  const host = window.location.hostname;
  const protocol = window.location.protocol;

  if (host === 'localhost') {
    return `http://localhost:4000`; // local dev backend
  }

  // test/prod na tym samym hostingu
  return `${protocol}//${host}`;
})();

const socket = socketIO.connect(API_URL);

function App() {
    const [tabletView, setTabletView] = useState(false);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const isTablet = params.get("mode") === "tablet";
        if(isTablet) {
            setTabletView(true);
        }

    }, []);

    return (
        <BrowserRouter>
            <div className={`app ${tabletView ? '-tablet' : ''}`}>
                {/*<div>work in progress</div>*/}
                <TabProvider>
                    <AppStateProvider socket={socket}>
                
                        <Routes>
                            <Route path="/" element={<Home socket={socket}/>}></Route>
                            <Route path="/game" element={<MainPage socket={socket}/>}></Route>
                            <Route path="/teams" element={<TeamsPage/>}></Route>
                        </Routes>
                    
                    </AppStateProvider>
                </TabProvider>
            </div>
        </BrowserRouter>
    );
}

export default App;
